import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import classNames from 'classnames';
import React, { FC, useCallback, useRef, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';

import { parseCallback, useNativeEventListener } from '@eika-infrastruktur/mobilbank-lib';

import { MenuItem } from '../MenuTypes';
import MenuElement from '../components/MenuElement';

export interface NativeMenu {
    nativeItems: MenuItem[];
    toggleMenu: () => void;
}

const Menu: FC<NativeMenu> = ({ nativeItems = [], toggleMenu }) => {
    const targetRef = useRef<HTMLUListElement>(null);

    useEffect(() => {
        const target = targetRef?.current;
        if (target) {
            disableBodyScroll(target);
        }
        return () => {
            if (target) {
                enableBodyScroll(target);
            }
        };
    }, [targetRef]);

    useNativeEventListener(
        useCallback(
            (event) => {
                const message = parseCallback(event.data);
                if (message?.action === 'BACK_TO_WEB') {
                    toggleMenu();
                }
            },
            [toggleMenu],
        ),
    );

    return (
        <CSSTransition in classNames="menu__list" timeout={300} unmountOnExit>
            <ul className="menu__list" ref={targetRef}>
                {nativeItems?.map((item) => (
                    <MenuElement
                        key={item.id ?? item.link.url}
                        menuItem={item}
                        className={classNames({ 'menu__item--small': item.small })}
                    />
                ))}
            </ul>
        </CSSTransition>
    );
};

export default Menu;
